import { motion } from 'framer-motion';
import FormDropdown from '../../../shared/components/FormDropdown';
import FormInputFloat from '../../../shared/components/FormInputFloat';
import { fadeIn } from '../../../shared/helpers/animation';
import Button from '../../../shared/components/Button';
import { SelectItem } from 'primereact/selectitem';

const NewClientStep1 = ({
  handleCloseModal,
  setActiveIndex,
  control,
  reset,
  errors,
  isValid,
}: {
  handleCloseModal: () => void;
  setActiveIndex: (index: number) => void;
  control: any;
  reset: () => void;
  errors: any;
  isValid: boolean;
}) => {
  const handleNext = () => {
    setActiveIndex(1);
  };

  // Table of age range mapped to average heart rate, 
  // as objects suitable for a select dropdown
  const ageBPMLookup : SelectItem[] = [
    { label: "0-2", value: 120 },
    { label: "2-3", value: 110 },
    { label: "3-5", value: 100 },
    { label: "5-6", value: 95 },
    { label: "6-10", value: 90 },
    { label: "10-12", value: 81 },
    { label: "12-13", value: 79 },
    { label: "13-18+", value: 75 },
  ];

  return (
    <motion.main
      className="mx-auto flex w-full flex-col items-stretch justify-between gap-y-2"
      variants={fadeIn}
      initial="hidden"
      animate="visible"
    >
      <FormInputFloat
        label="First name (or alias)"
        name="firstName"
        control={control}
        rules={{
          required: {
            value: true,
            message: 'First name is required',
          },
        }}
        errors={errors}
      />
      <FormInputFloat
        label="Last name (or alias)"
        name="lastName"
        control={control}
        rules={{
          required: {
            value: true,
            message: 'Last name is required',
          },
        }}
        errors={errors}
      />
      <FormInputFloat
        label="User ID (optional)"
        name="externalClientId"
        control={control}
        errors={errors}
      />
      <FormDropdown
        label="Age Range"
        name="bpmForAge"
        control={control}
        errors={errors}
        options={ageBPMLookup}
        rules={{
          required: {
            value: true,
            message: 'Age is required',
          },
        }}
      />
      <div className="flex gap-x-4">
        <Button
          label="Cancel"
          className="p-button-outlined p-button-info"
          onClick={() => handleCloseModal()}
        />
        <Button
          className="p-button-info grow"
          onClick={() => handleNext()}
          disabled={!isValid}
          label="Continue"
        />
      </div>
    </motion.main>
  );
};

export default NewClientStep1;
